export const BLACKLISTEDKEYS = ["id", "geometry", "centroid", "longitude", "latitude", "demographic"]